import React, { useState, useEffect } from "react";
import { CustomTitle } from "../../../components";
import {Form, Row, Col, message} from "antd";
import { GetCompnayInfo, SubmitCompnayInfo } from "../../../api's/settings";
import { useToken } from "../../../common/helper";
import { CustomButton, CustomInput } from "../../../components";
import { useSpin } from "../../../components/SpinContext";
import { useNavigate } from "react-router-dom";

const CompanyInfo = ({ title }) => {
  const [form] = Form.useForm();
  const { token, removeToken, } = useToken();
  const { showSpin, hideSpin } = useSpin();
  const navigate = useNavigate();

  const [isFormValid, setIsFormValid] = useState(false);

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  useEffect(() => {
    showSpin();
    GetCompnayInfo(token)
      .then((res) => {
        const data = res?.data?.data?.data;
        form.setFieldsValue({
          name: data?.name || "",
        });
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  }, [token]);

  const onFinish = (values) => {
    const model = {
      ...values,
    };
    handleSubmitCompanyInfo(model);
  };

  const handleSubmitCompanyInfo = (model) => {
    setIsFormValid(true);
    showSpin();
    SubmitCompnayInfo(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            message.success(data?.data?.message);
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
        setIsFormValid(false);
      });
  };

  return (
    <div className="settings-content-wrapper">
      <CustomTitle
        text={title}
        fontSize={20}
        fontWeight="700"
        lineHeight="28px"
        color="#000"
        marginBottom={24}
      />

      <Form
        form={form}
        name="ProfileForm"
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
        initialValues={{
          name: "",
        }}
      >
        <Row gutter={14}>
          <Col xs={24} sm={24} md={12} lg={6} xl={6} xxl={6}>
            <Form.Item
              className="custom-input form-input-style"
              label="Name"
              name="name"
              rules={[
                { required: true, message: "Please enter company name" },
                {
                  min: 2,
                  message: "Name must be at least 2 characters long",
                },
                {
                  pattern: /^[A-Za-z0-9\s'-]+$/,
                  message: "Please enter a valid value (letters, numbers, spaces, hyphens only)",
                }
                
              ]}
              style={{ marginBottom: "0px" }}
            >
              <CustomInput
                placeholder="Enter company name"
                height="36px"
                border="0px"
                bgColor="#F3F3F3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                lineHeight="38px"
              />
            </Form.Item>
          </Col>
        </Row>
        <CustomButton
          text="Save"
          width={107}
          height={36}
          borderRadius={8}
          bgColor="#000"
          color="#fff"
          border="0px"
          fontSize={14}
          fontWeight={600}
          htmlType="submit"
          marginTop={36}
          isFormValid={isFormValid}
        />
      </Form>
    </div>
  );
};

export default CompanyInfo;
